import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { IBenefit, IClient, IParticipant } from '../../shared/models/book-of-business.interface';
import { BookOfBusinessService } from '../../shared/services/book-of-business.service';

const MOCK_DATA: IClient[] = [
  /*
  {
    clientId: 1, clientName: 'John Doe', packageName: 'FlexAdvantage Max',
    totalMonthly: 230.49, state: 'TX',
    agentName: 'Bob Smith', agentNPN: '16857423', memberId: '1234567',
    participants: [
      { participantId: 1, name: 'John Doe', gender: 'M', dob: '1980-05-15', role: 'Primary', address: '123 Main St', city: 'Dallas', state: 'TX', zip: '75201', phone: '214-555-0123', email: 'john.doe@email.com' },
      { participantId: 2, name: 'Jane Doe', gender: 'F', dob: '1982-08-22', role: 'Spouse', address: '123 Main St', city: 'Dallas', state: 'TX', zip: '75201' },
    ],
    benefits: [
      { benefitId: 1, participantName: 'John Doe', productName: 'FlexAccident', benefitName: 'Accident Medical Expense', amount: 5000, effectiveDate: '2024-01-01', termDate: '2027-01-01', monthlyAmount: 125.50 },
      { benefitId: 2, participantName: 'John Doe', productName: 'FlexAccident', benefitName: 'Accidental Death', amount: 25000, effectiveDate: '2024-01-01', termDate: '2027-01-01', monthlyAmount: 125.50 },
      { benefitId: 3, participantName: 'John Doe', productName: 'FlexAccident', benefitName: 'Accident Disability Income', amount: 500, effectiveDate: '2024-01-01', termDate: '2027-01-01', monthlyAmount: 125.50 },
      { benefitId: 4, participantName: 'John Doe', productName: 'FlexAccident', benefitName: 'Sickness Hospital Stays', amount: 5000, effectiveDate: '2024-01-01', termDate: '2027-01-01', monthlyAmount: 125.50 },
      { benefitId: 5, participantName: 'John Doe', productName: 'FlexCritical Illness', benefitName: 'Critical Illness (Cancer, Heart Attack, Stroke)', amount: 15000, effectiveDate: '2024-01-10', termDate: '2027-01-10', monthlyAmount: 89.99 },
    ],
  },
  {
    clientId: 2, clientName: 'Sarah Johnson', packageName: 'FlexProtect Pro',
    totalMonthly: 145.00, state: 'CA',
    agentName: 'Margaret Miller', agentNPN: '15328521', memberId: '2345678',
    participants: [
      { participantId: 3, name: 'Sarah Johnson', gender: 'F', dob: '1985-09-12', role: 'Primary', address: '456 Oak Avenue', city: 'Los Angeles', state: 'CA', zip: '90001', phone: '310-555-0456', email: 'sarah.johnson@email.com' },
    ],
    benefits: [
      { benefitId: 11, participantName: 'Sarah Johnson', productName: 'FlexAccident', benefitName: 'Accident Medical Expense', amount: 5000, effectiveDate: '2024-03-15', termDate: '2027-03-15', monthlyAmount: 110.00 },
      { benefitId: 12, participantName: 'Sarah Johnson', productName: 'FlexAccident', benefitName: 'Accidental Death', amount: 25000, effectiveDate: '2024-03-15', termDate: '2027-03-15', monthlyAmount: 110.00 },
      { benefitId: 13, participantName: 'Sarah Johnson', productName: 'Association', benefitName: 'Association Membership', amount: 'Premium', effectiveDate: '2024-03-15', termDate: '2027-03-15', monthlyAmount: 35.00 },
    ],
  },
  {
    clientId: 3, clientName: 'Michael Smith', packageName: 'FlexGap Essential',
    totalMonthly: 89.99, state: 'FL',
    agentName: 'Bob Smith', agentNPN: '16857423', memberId: '3456789',
    participants: [
      { participantId: 4, name: 'Michael Smith', gender: 'M', dob: '1975-11-03', role: 'Primary', address: '789 Beach Boulevard', city: 'Miami', state: 'FL', zip: '33101', phone: '305-555-0789', email: 'michael.smith@email.com' },
    ],
    benefits: [
      { benefitId: 14, participantName: 'Michael Smith', productName: 'FlexCritical Illness', benefitName: 'Critical Illness (Cancer, Heart Attack, Stroke)', amount: 15000, effectiveDate: '2025-01-10', termDate: '2028-01-10', monthlyAmount: 89.99 },
    ],
  },
  {
    clientId: 4, clientName: 'Emily Rodriguez', packageName: 'FlexAdvantage Max',
    totalMonthly: 215.49, state: 'NY',
    agentName: 'Margaret Miller', agentNPN: '15328521', memberId: '4567890',
    participants: [
      { participantId: 5, name: 'Emily Rodriguez', gender: 'F', dob: '1988-03-20', role: 'Primary', address: '456 Park Avenue', city: 'New York', state: 'NY', zip: '10022', phone: '212-555-1234', email: 'emily.rodriguez@email.com' },
    ],
    benefits: [
      { benefitId: 15, participantName: 'Emily Rodriguez', productName: 'FlexAccident', benefitName: 'Accident Medical Expense', amount: 5000, effectiveDate: '2024-06-01', termDate: '2027-06-01', monthlyAmount: 135.50 },
      { benefitId: 16, participantName: 'Emily Rodriguez', productName: 'FlexAccident', benefitName: 'Accidental Death', amount: 25000, effectiveDate: '2024-06-01', termDate: '2027-06-01', monthlyAmount: 135.50 },
      { benefitId: 17, participantName: 'Emily Rodriguez', productName: 'FlexCritical Illness', benefitName: 'Critical Illness (Cancer, Heart Attack, Stroke)', amount: 10000, effectiveDate: '2024-06-01', termDate: '2027-06-01', monthlyAmount: 64.99 },
      { benefitId: 18, participantName: 'Emily Rodriguez', productName: 'Association', benefitName: 'Association Membership', amount: 'Basic', effectiveDate: '2024-06-01', termDate: '2027-06-01', monthlyAmount: 15.00 },
    ],
  },
  {
    clientId: 5, clientName: 'Robert Chen', packageName: 'FlexProtect Pro',
    totalMonthly: 175.50, state: 'CA',
    agentName: 'Bob Smith', agentNPN: '16857423', memberId: '5678901',
    participants: [
      { participantId: 6, name: 'Robert Chen', gender: 'M', dob: '1979-07-14', role: 'Primary', address: '789 Silicon Valley Drive', city: 'San Jose', state: 'CA', zip: '95110', phone: '408-555-2345', email: 'robert.chen@email.com' },
      { participantId: 7, name: 'Lisa Chen', gender: 'F', dob: '1981-05-22', role: 'Spouse', address: '789 Silicon Valley Drive', city: 'San Jose', state: 'CA', zip: '95110' },
    ],
    benefits: [
      { benefitId: 19, participantName: 'Robert Chen', productName: 'FlexAccident', benefitName: 'Accident Medical Expense', amount: 5000, effectiveDate: '2023-11-15', termDate: '2026-11-15', monthlyAmount: 110.50 },
      { benefitId: 20, participantName: 'Robert Chen', productName: 'FlexAccident', benefitName: 'Accidental Death', amount: 25000, effectiveDate: '2023-11-15', termDate: '2026-11-15', monthlyAmount: 110.50 },
      { benefitId: 21, participantName: 'Robert Chen', productName: 'FlexAccident', benefitName: 'Accident Disability Income', amount: 500, effectiveDate: '2023-11-15', termDate: '2026-11-15', monthlyAmount: 110.50 },
      { benefitId: 24, participantName: 'Robert Chen', productName: 'FlexCritical Illness', benefitName: 'Critical Illness (Cancer, Heart Attack, Stroke)', amount: 10000, effectiveDate: '2023-11-15', termDate: '2026-11-15', monthlyAmount: 65.00 },
    ],
  },
  {
    clientId: 6, clientName: 'Amanda Taylor', packageName: 'FlexGap Essential',
    totalMonthly: 125.00, state: 'TX',
    agentName: 'Margaret Miller', agentNPN: '15328521', memberId: '6789012',
    participants: [
      { participantId: 8, name: 'Amanda Taylor', gender: 'F', dob: '1992-01-30', role: 'Primary', address: '321 Austin Street', city: 'Austin', state: 'TX', zip: '78701', phone: '512-555-3456', email: 'amanda.taylor@email.com' },
    ],
    benefits: [
      { benefitId: 25, participantName: 'Amanda Taylor', productName: 'FlexAccident', benefitName: 'Accident Medical Expense', amount: 5000, effectiveDate: '2025-02-01', termDate: '2028-02-01', monthlyAmount: 125.00 },
      { benefitId: 26, participantName: 'Amanda Taylor', productName: 'FlexAccident', benefitName: 'Accidental Death', amount: 25000, effectiveDate: '2025-02-01', termDate: '2028-02-01', monthlyAmount: 125.00 },
    ],
  },
  {
    clientId: 7, clientName: 'David Wilson', packageName: 'FlexProtect Pro',
    totalMonthly: 104.99, state: 'IL',
    agentName: 'Bob Smith', agentNPN: '16857423', memberId: '7890123',
    participants: [
      { participantId: 9, name: 'David Wilson', gender: 'M', dob: '1973-12-05', role: 'Primary', address: '654 Michigan Avenue', city: 'Chicago', state: 'IL', zip: '60601', phone: '312-555-4567', email: 'david.wilson@email.com' },
      { participantId: 10, name: 'Patricia Wilson', gender: 'F', dob: '1975-04-18', role: 'Spouse', address: '654 Michigan Avenue', city: 'Chicago', state: 'IL', zip: '60601' },
    ],
    benefits: [
      { benefitId: 27, participantName: 'David Wilson', productName: 'FlexCritical Illness', benefitName: 'Critical Illness (Cancer, Heart Attack, Stroke)', amount: 15000, effectiveDate: '2024-08-01', termDate: '2027-08-01', monthlyAmount: 89.99 },
      { benefitId: 28, participantName: 'Patricia Wilson', productName: 'FlexCritical Illness', benefitName: 'Critical Illness (Cancer, Heart Attack, Stroke)', amount: 10000, effectiveDate: '2024-08-01', termDate: '2027-08-01', monthlyAmount: 89.99 },
      { benefitId: 29, participantName: 'David Wilson', productName: 'Association', benefitName: 'Association Membership', amount: 'Basic', effectiveDate: '2024-08-01', termDate: '2027-08-01', monthlyAmount: 15.00 },
    ],
  },
  {
    clientId: 8, clientName: 'Jennifer Martinez', packageName: 'FlexAdvantage Max',
    totalMonthly: 240.49, state: 'AZ',
    agentName: 'Margaret Miller', agentNPN: '15328521', memberId: '8901234',
    participants: [
      { participantId: 11, name: 'Jennifer Martinez', gender: 'F', dob: '1986-06-25', role: 'Primary', address: '987 Desert Road', city: 'Phoenix', state: 'AZ', zip: '85001', phone: '602-555-5678', email: 'jennifer.martinez@email.com' },
      { participantId: 12, name: 'Carlos Martinez', gender: 'M', dob: '1984-09-10', role: 'Spouse', address: '987 Desert Road', city: 'Phoenix', state: 'AZ', zip: '85001' },
    ],
    benefits: [
      { benefitId: 30, participantName: 'Jennifer Martinez', productName: 'FlexAccident', benefitName: 'Accident Medical Expense', amount: 5000, effectiveDate: '2024-04-20', termDate: '2027-04-20', monthlyAmount: 130.50 },
      { benefitId: 31, participantName: 'Jennifer Martinez', productName: 'FlexAccident', benefitName: 'Accidental Death', amount: 25000, effectiveDate: '2024-04-20', termDate: '2027-04-20', monthlyAmount: 130.50 },
      { benefitId: 32, participantName: 'Jennifer Martinez', productName: 'FlexAccident', benefitName: 'Accident Disability Income', amount: 500, effectiveDate: '2024-04-20', termDate: '2027-04-20', monthlyAmount: 130.50 },
      { benefitId: 35, participantName: 'Jennifer Martinez', productName: 'FlexCritical Illness', benefitName: 'Critical Illness (Cancer, Heart Attack, Stroke)', amount: 10000, effectiveDate: '2024-04-20', termDate: '2027-04-20', monthlyAmount: 94.99 },
      { benefitId: 37, participantName: 'Jennifer Martinez', productName: 'Association', benefitName: 'Association Membership', amount: 'Basic', effectiveDate: '2024-04-20', termDate: '2027-04-20', monthlyAmount: 15.00 },
    ],
  },
  {
    clientId: 9, clientName: 'Thomas Anderson', packageName: 'FlexGap Essential',
    totalMonthly: 95.50, state: 'WA',
    agentName: 'Bob Smith', agentNPN: '16857423', memberId: '9012345',
    participants: [
      { participantId: 13, name: 'Thomas Anderson', gender: 'M', dob: '1990-02-14', role: 'Primary', address: '123 Seattle Way', city: 'Seattle', state: 'WA', zip: '98101', phone: '206-555-6789', email: 'thomas.anderson@email.com' },
    ],
    benefits: [
      { benefitId: 38, participantName: 'Thomas Anderson', productName: 'FlexAccident', benefitName: 'Accident Medical Expense', amount: 5000, effectiveDate: '2025-03-01', termDate: '2028-03-01', monthlyAmount: 95.50 },
      { benefitId: 39, participantName: 'Thomas Anderson', productName: 'FlexAccident', benefitName: 'Accidental Death', amount: 25000, effectiveDate: '2025-03-01', termDate: '2028-03-01', monthlyAmount: 95.50 },
    ],
  },
  {
    clientId: 10, clientName: 'Maria Garcia', packageName: 'FlexProtect Pro',
    totalMonthly: 155.49, state: 'TX',
    agentName: 'Margaret Miller', agentNPN: '15328521', memberId: '1012345',
    participants: [
      { participantId: 14, name: 'Maria Garcia', gender: 'F', dob: '1983-08-08', role: 'Primary', address: '555 Rio Grande Street', city: 'Houston', state: 'TX', zip: '77002', phone: '713-555-7890', email: 'maria.garcia@email.com' },
    ],
    benefits: [
      { benefitId: 40, participantName: 'Maria Garcia', productName: 'FlexAccident', benefitName: 'Accident Medical Expense', amount: 5000, effectiveDate: '2024-09-15', termDate: '2027-09-15', monthlyAmount: 115.50 },
      { benefitId: 41, participantName: 'Maria Garcia', productName: 'FlexAccident', benefitName: 'Accidental Death', amount: 25000, effectiveDate: '2024-09-15', termDate: '2027-09-15', monthlyAmount: 115.50 },
      { benefitId: 43, participantName: 'Maria Garcia', productName: 'Association', benefitName: 'Association Membership', amount: 'Premium', effectiveDate: '2024-09-15', termDate: '2027-09-15', monthlyAmount: 39.99 },
    ],
  },
  {
    clientId: 11, clientName: 'Christopher Brown', packageName: 'FlexAdvantage Max',
    totalMonthly: 205.48, state: 'GA',
    agentName: 'Bob Smith', agentNPN: '16857423', memberId: '1123456',
    participants: [
      { participantId: 15, name: 'Christopher Brown', gender: 'M', dob: '1977-10-19', role: 'Primary', address: '888 Peachtree Street', city: 'Atlanta', state: 'GA', zip: '30303', phone: '404-555-8901', email: 'christopher.brown@email.com' },
      { participantId: 16, name: 'Michelle Brown', gender: 'F', dob: '1979-03-28', role: 'Spouse', address: '888 Peachtree Street', city: 'Atlanta', state: 'GA', zip: '30303' },
    ],
    benefits: [
      { benefitId: 44, participantName: 'Christopher Brown', productName: 'FlexAccident', benefitName: 'Accident Medical Expense', amount: 5000, effectiveDate: '2024-07-10', termDate: '2027-07-10', monthlyAmount: 120.49 },
      { benefitId: 45, participantName: 'Christopher Brown', productName: 'FlexAccident', benefitName: 'Accidental Death', amount: 25000, effectiveDate: '2024-07-10', termDate: '2027-07-10', monthlyAmount: 120.49 },
      { benefitId: 49, participantName: 'Christopher Brown', productName: 'FlexCritical Illness', benefitName: 'Critical Illness (Cancer, Heart Attack, Stroke)', amount: 10000, effectiveDate: '2024-07-10', termDate: '2027-07-10', monthlyAmount: 69.99 },
      { benefitId: 50, participantName: 'Christopher Brown', productName: 'Association', benefitName: 'Association Membership', amount: 'Basic', effectiveDate: '2024-07-10', termDate: '2027-07-10', monthlyAmount: 15.00 },
    ],
  },
  {
    clientId: 12, clientName: 'Lisa Thompson', packageName: 'FlexGap Essential',
    totalMonthly: 79.99, state: 'NC',
    agentName: 'Margaret Miller', agentNPN: '15328521', memberId: '1234568',
    participants: [
      { participantId: 17, name: 'Lisa Thompson', gender: 'F', dob: '1991-05-16', role: 'Primary', address: '222 Carolina Avenue', city: 'Charlotte', state: 'NC', zip: '28201', phone: '704-555-9012', email: 'lisa.thompson@email.com' },
    ],
    benefits: [
      { benefitId: 51, participantName: 'Lisa Thompson', productName: 'FlexCritical Illness', benefitName: 'Critical Illness (Cancer, Heart Attack, Stroke)', amount: 12000, effectiveDate: '2024-12-01', termDate: '2027-12-01', monthlyAmount: 79.99 },
    ],
  },
  {
    clientId: 13, clientName: 'James Williams', packageName: 'FlexProtect Pro',
    totalMonthly: 190.99, state: 'PA',
    agentName: 'Bob Smith', agentNPN: '16857423', memberId: '1345679',
    participants: [
      { participantId: 18, name: 'James Williams', gender: 'M', dob: '1972-11-11', role: 'Primary', address: '777 Liberty Street', city: 'Philadelphia', state: 'PA', zip: '19103', phone: '215-555-0123', email: 'james.williams@email.com' },
      { participantId: 19, name: 'Susan Williams', gender: 'F', dob: '1974-02-24', role: 'Spouse', address: '777 Liberty Street', city: 'Philadelphia', state: 'PA', zip: '19103' },
    ],
    benefits: [
      { benefitId: 52, participantName: 'James Williams', productName: 'FlexAccident', benefitName: 'Accident Medical Expense', amount: 5000, effectiveDate: '2024-05-20', termDate: '2027-05-20', monthlyAmount: 140.00 },
      { benefitId: 53, participantName: 'James Williams', productName: 'FlexAccident', benefitName: 'Accidental Death', amount: 25000, effectiveDate: '2024-05-20', termDate: '2027-05-20', monthlyAmount: 140.00 },
      { benefitId: 57, participantName: 'James Williams', productName: 'Association', benefitName: 'Association Membership', amount: 'Premium', effectiveDate: '2024-05-20', termDate: '2027-05-20', monthlyAmount: 50.99 },
    ],
  },*/
];

interface IClientView extends IClient {
  visibleBenefitsSorted: IBenefit[];
  participantsSorted: IParticipant[];
  paidToDate: string | null;
}

@Component({
  selector: 'app-book-of-business',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatIconModule, MatCardModule],
  templateUrl: './book-of-business.component.html',
  styleUrl: './book-of-business.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookOfBusinessComponent implements OnInit {
  searchTerm = '';
  expandedClients: Record<number, boolean> = {};
  expandedParticipants: Record<number, boolean> = {};
  expandedBenefits: Record<number, boolean> = {};

  currentPage = 1;
  itemsPerPage = 10;

  showExportPanel = false;
  filterEffectiveDateFrom = '';
  filterEffectiveDateTo = '';
  filterTermDateFrom = '';
  filterTermDateTo = '';
  isLoading = true;

  private data: IClient[] = [];
  filteredClients: IClientView[] = [];

  constructor(
    private router: Router,
    private bookOfBusinessService: BookOfBusinessService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.bookOfBusinessService.getBookOfBusiness().subscribe(data => {
      this.data = data;
      this.applyFilter();
      this.isLoading = false;
      this.cdr.markForCheck();
    });
  }

  private applyFilter(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredClients = this.data
      .filter(c =>
        c.clientName.toLowerCase().includes(term) ||
        c.memberId.includes(term) ||
        c.agentName.toLowerCase().includes(term) ||
        c.agentNPN.includes(term),
      )
      .sort((a, b) => b.memberId.localeCompare(a.memberId, undefined, { numeric: true }))
      .map(c => ({
        ...c,
        visibleBenefitsSorted: this.computeVisibleBenefits(c.benefits),
        participantsSorted: this.computeSortedParticipants(c.participants),
        paidToDate: this.maxDate(c.benefits, 'paidToDate'),
      }));
  }

  get totalPages(): number {
    return Math.ceil(this.filteredClients.length / this.itemsPerPage);
  }

  get startIndex(): number {
    return (this.currentPage - 1) * this.itemsPerPage;
  }

  get endIndex(): number {
    return Math.min(this.startIndex + this.itemsPerPage, this.filteredClients.length);
  }

  get paginatedData(): IClientView[] {
    return this.filteredClients.slice(this.startIndex, this.endIndex);
  }

  get hasActiveFilters(): boolean {
    return !!(this.filterEffectiveDateFrom || this.filterEffectiveDateTo ||
              this.filterTermDateFrom || this.filterTermDateTo);
  }

  get totalMonthlyPremium(): number {
    return this.filteredClients.reduce((sum, c) => sum + c.totalMonthly, 0);
  }

  get totalStates(): number {
    return new Set(this.filteredClients.map(c => c.state)).size;
  }

  onSearch(value: string): void {
    this.searchTerm = value;
    this.currentPage = 1;
    this.applyFilter();
  }

  toggleClient(id: number): void {
    this.expandedClients[id] = !this.expandedClients[id];
  }

  toggleParticipants(id: number): void {
    this.expandedParticipants[id] = !this.expandedParticipants[id];
  }

  toggleBenefits(id: number): void {
    this.expandedBenefits[id] = !this.expandedBenefits[id];
  }

  goBack(): void {
    this.router.navigate(['dashboard']);
  }

  setItemsPerPage(value: number): void {
    this.itemsPerPage = value;
    this.currentPage = 1;
  }

  clearFilters(): void {
    this.filterEffectiveDateFrom = '';
    this.filterEffectiveDateTo = '';
    this.filterTermDateFrom = '';
    this.filterTermDateTo = '';
  }

  private isDateInRange(date: string, from: string, to: string): boolean {
    if (!from && !to) return true;
    const d = new Date(date);
    if (from && new Date(from) > d) return false;
    if (to && new Date(to) < d) return false;
    return true;
  }

  downloadCsv(): void {
    const records = this.data.filter(client => {
      if (!this.hasActiveFilters) return true;
      return client.benefits.some(b =>
        this.isDateInRange(b.effectiveDate, this.filterEffectiveDateFrom, this.filterEffectiveDateTo) &&
        this.isDateInRange(b.termDate, this.filterTermDateFrom, this.filterTermDateTo),
      );
    }).map(c => ({
      'Member ID': c.memberId,
      'Client Name': c.clientName,
      'Package Name': c.packageName,
      'Total Price': c.totalMonthly.toFixed(2),
      'Agent Name': c.agentName,
      'Agent NPN': c.agentNPN,
      'Effective Date': this.maxDate(c.benefits, 'effectiveDate') ?? '',
      'Paid To Date': this.maxDate(c.benefits, 'paidToDate') ?? '',
      'Term Date': this.maxDate(c.benefits, 'termDate') ?? '',
      'State': c.state,
      'StatusType': c.statusType,
    }));

    if (records.length === 0) {
      alert('No records match the selected filters.');
      return;
    }

    const headers = Object.keys(records[0]);
    const csv = [
      headers.join(','),
      ...records.map(r =>
        headers.map(h => {
          const v = (r as Record<string, string>)[h];
          return v.includes(',') || v.includes('"') ? `"${v.replace(/"/g, '""')}"` : v;
        }).join(','),
      ),
    ].join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `book_of_business_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  }

  formatAmount(amount: number | string): string {
    return typeof amount === 'number' ? `$${amount.toLocaleString()}` : amount;
  }

  private computeVisibleBenefits(benefits: IBenefit[]): IBenefit[] {
    return [...benefits]
      .filter(b => b.amount !== 0)
      .sort((a, b) => {
        const byProduct = a.productName.localeCompare(b.productName);
        if (byProduct !== 0) return byProduct;
        return a.benefitName.localeCompare(b.benefitName);
      });
  }

  private computeSortedParticipants(participants: IParticipant[]): IParticipant[] {
    const rank = (role: string): number => {
      const r = (role || '').toLowerCase();
      if (r === 'primary') return 0;
      if (r === 'spouse') return 1;
      return 2;
    };
    return [...participants].sort((a, b) => {
      const diff = rank(a.role) - rank(b.role);
      if (diff !== 0) return diff;
      return new Date(a.dob).getTime() - new Date(b.dob).getTime();
    });
  }

  private maxDate(benefits: IBenefit[], key: 'effectiveDate' | 'paidToDate' | 'termDate'): string | null {
    const dates = benefits.map(b => b[key]).filter(Boolean);
    if (dates.length === 0) return null;
    return dates.reduce((max, d) => (d > max ? d : max));
  }
}
